import { useEffect, useState } from 'react';
import { getProfile, getSegments, getDiscipline, disciplineCopy } from './segment.js';

// Subscribes to profile + segment changes so any component re-renders when the
// user switches discipline (medicine ↔ dentistry) or toggles a segment.
export function useProfile() {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const onChange = () => setTick((t) => t + 1);
    window.addEventListener('mm-profile-change', onChange);
    window.addEventListener('mm-segments-change', onChange);
    window.addEventListener('storage', onChange);
    return () => {
      window.removeEventListener('mm-profile-change', onChange);
      window.removeEventListener('mm-segments-change', onChange);
      window.removeEventListener('storage', onChange);
    };
  }, []);
  return {
    profile: getProfile(),
    segments: getSegments(),
    discipline: getDiscipline(),
    copy: disciplineCopy(),
    refresh: () => setTick((t) => t + 1)
  };
}
